import { Box } from '@mui/material';
import { useConsole } from '../../contexts/ConsoleContext';
import { ChatPanel } from '../chat/ChatPanel';
import { GamePanel } from '../panels/GamePanel';
import { ShipPanel } from '../panels/ShipPanel';
import { LocationPanel } from '../panels/LocationPanel';
import { MissionsPanel } from '../panels/MissionsPanel';
import { MarketPanel } from '../panels/MarketPanel';
import { MapPanel } from '../panels/MapPanel';
import { NPCsPanel } from '../panels/NPCsPanel';
import { RepairsPanel } from '../panels/RepairsPanel';
import { HistoryPanel } from '../panels/HistoryPanel';
import { LogViewer } from './LogViewer';
import { D1Browser } from './D1Browser';
import { R2Browser } from './R2Browser';
import { DatabaseAdminPanel } from '../panels/DatabaseAdminPanel';
import { AIConsolePanel } from '../panels/AIConsolePanel';
import { PineconeTestPanel } from '../panels/PineconeTestPanel';
import { VoiceTestPanel } from '../panels/VoiceTestPanel';

interface PanelContainerProps {
  playerId: string;
}

export function PanelContainer({ playerId }: PanelContainerProps) {
  const { selectedPanel, debugMode } = useConsole();

  const renderPanel = () => {
    // Redirect debug panels to chat if debug mode is off
    const isDebugPanel = selectedPanel === 'logs' || selectedPanel === 'db-browser' || selectedPanel === 'r2-browser' || selectedPanel === 'database-admin' || selectedPanel === 'ai-console' || selectedPanel === 'pinecone-test' || selectedPanel === 'voice-test';
    if (isDebugPanel && !debugMode) {
      return <ChatPanel />;
    }

    switch (selectedPanel) {
      case 'chat':
        return <ChatPanel />;
      case 'game':
        return <GamePanel playerId={playerId} />;
      case 'ship':
        return <ShipPanel playerId={playerId} />;
      case 'location':
        return <LocationPanel playerId={playerId} />;
      case 'cargo':
        // Cargo panel merged with ship panel
        return <ShipPanel playerId={playerId} />;
      case 'missions':
        return <MissionsPanel playerId={playerId} />;
      case 'market':
        return <MarketPanel playerId={playerId} />;
      case 'map':
        return <MapPanel playerId={playerId} />;
      case 'npcs':
        return <NPCsPanel playerId={playerId} />;
      case 'repairs':
        return <RepairsPanel playerId={playerId} />;
      case 'history':
        return <HistoryPanel />;
      case 'logs':
        return <LogViewer />;
      case 'db-browser':
        return <D1Browser />;
      case 'r2-browser':
        return <R2Browser />;
      case 'database-admin':
        return <DatabaseAdminPanel playerId={playerId} />;
      case 'ai-console':
        return <AIConsolePanel />;
      case 'pinecone-test':
        return <PineconeTestPanel />;
      case 'voice-test':
        return <VoiceTestPanel proxyUrl={import.meta.env.VITE_ELEVENLABS_PROXY_URL || 'https://space-antics-elevenlabs-staging.parkins-d93jed72hfs91np.workers.dev'} />;
      default:
        return <ChatPanel />;
    }
  };

  return (
    <Box className="panel-container">
      {renderPanel()}
    </Box>
  );
}
